import { Component, Input } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ReportsViewEnum } from 'src/app/reports/models/enums/reports.enum';
import { ReportService } from 'src/app/reports/services/report.service';
import { HouseVillasReportConstant } from '../../../report-house-villas/report-house-villas.constants';
import { SharedService } from 'src/app/common/services/shared.service';
import { HouseVillaPropertyDetailConstant } from './housevilla-property-details.constant';
import { HouseVillaPropertyDetailMenuEnum } from './housevilla-property-detail.enum';
import { PropertyCategoryEnum } from '../../propertyCategory.enum';

@Component({
  selector: 'app-housevilla-property-detail',
  templateUrl: './housevilla-property-detail.component.html',
  styleUrls: ['./housevilla-property-detail.component.scss']
})
export class HousevillaPropertyDetailComponent {
  @Input() propertyInfo: any;
  currentLang: string = '';
  currentReportView: number = ReportsViewEnum.mapView;
  overViewMenu = HouseVillaPropertyDetailConstant.overViewMenu;
  currentScroll: any = '';
  housePropertyDetailMenuEnum = HouseVillaPropertyDetailMenuEnum;
  private destroy$ = new Subject<void>(); // Subject to trigger unsubscribe
  propertyCategory = PropertyCategoryEnum;

  constructor(
      public reportService: ReportService,
      private sharedService: SharedService
    ) {}

    ngOnInit(): void {
    // this.setLang();
    this.getReportView();
  }

  backToTransaction() {
    if(!this.reportService.projectReportView){
       this.reportService.isDetailPageOpen = false;
    }  
    // this.reportService.isDetailPageOpen = false;
    this.reportService.transactionPropertyDetails.next(false);
  }
  getReportView() {
    this.reportService.reportView$
    .pipe(takeUntil(this.destroy$))
    .subscribe((view: number) => {
      this.currentReportView = view;
    });
  }
  menuChangeValue(menu: any) {
    this.currentScroll = menu.name;
    setTimeout(() => {
      this.scrollPoint(menu.name);
    })
  }
  scrollPoint(menu: string) {
    this.sharedService.scrollMenu(menu);
  }
  ngOnDestroy() {
    this.destroy$.next(); // Emit signal to unsubscribe
    this.destroy$.complete(); // Clean up the Subject
  }
}
